import { render, staticRenderFns } from "./touss2.vue?vue&type=template&id=c09bc4c0&scoped=true&"
import script from "./touss2.vue?vue&type=script&lang=js&"
export * from "./touss2.vue?vue&type=script&lang=js&"
import style0 from "./touss2.vue?vue&type=style&index=0&id=c09bc4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09bc4c0",
  null
  
)

export default component.exports